import React from "react";
import { Box, CircularProgress, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Outlet } from "react-router-dom";
import { PageChromeProvider } from "./PageChromeContext";
import { ProjectsProvider } from "./ProjectsContext";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

export const SIDEBAR_WIDTH = 248;

const AdminLayout: React.FC = () => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [mobileOpen, setMobileOpen] = React.useState(false);

  return (
    <PageChromeProvider>
      <ProjectsProvider>
        <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
          <Sidebar
            width={SIDEBAR_WIDTH}
            permanent={isMdUp}
            mobileOpen={mobileOpen}
            onMobileClose={() => setMobileOpen(false)}
          />
          <Box
            component="main"
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <TopBar showMenuButton={!isMdUp} onMenuClick={() => setMobileOpen(true)} />
            <Box sx={{ p: { xs: 2, md: 3 }, flex: 1 }}>
              <React.Suspense
                fallback={
                  <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                    <CircularProgress />
                  </Box>
                }
              >
                <Outlet />
              </React.Suspense>
            </Box>
          </Box>
        </Box>
      </ProjectsProvider>
    </PageChromeProvider>
  );
};

export default AdminLayout;
